import React from "react";
import about2 from "../../assets/img/about-2.jpg";
import about3 from "../../assets/img/about-3.jpg";

function About() {
  return (
    <div class="container-xxl py-6">
        <div class="container">
          <div class="row g-5">
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div
                class="position-relative overflow-hidden ps-5 pt-5 h-100"
                style={{ minHeight: "400px" }}
              >
                <img
                  class="position-absolute w-100 h-100"
                  src={about3}
                  alt=""
                  style={{ objectFit: "cover" }}
                />
                <img
                  class="position-absolute top-0 start-0 bg-white pe-3 pb-3"
                  src={about2}
                  alt=""
                  style={{ width: "200px", height: "200px" }}
                />
              </div>
            </div>
            <div class="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <div class="h-100">
                <h6 class="text-primary text-uppercase mb-2">About Us</h6>
                <h1 class="display-6 mb-4">
                    Ignite Growth with Revtech
                </h1>
                <p>
                  Tired of innovation that hinders progress instead of fueling it? Revtech empowers you to make bold technology choices. We ensure your IT ecosystem is streamlined, efficient, and ready to cut through the noise of trendy solutions to deliver real-world results.
                </p>
                <p class="mb-4">
                  Our IT consulting experts are architects of transformation. We bridge the gap between your business goals and your IT needs and systems. Leverage our unparalleled technical expertise and deep industry knowledge to unlock highly actionable and agile IT strategies.
                </p>
                {/* <div class="row g-2 mb-4 pb-2">
                  <div class="col-sm-6">
                    <i class="fa fa-certificate text-primary me-2"></i>
                    Experience
                  </div>
                  <div class="col-sm-6">
                    <i class="fa fa-fighter-jet text-primary me-2"></i>Quick
                    Support
                  </div>
                  <div class="col-sm-6">
                    <i class="fa fa-money-bill text-primary me-2"></i>Afordable
                    Fee
                  </div>
                  <div class="col-sm-6">
                    <i class="fa fa-users text-primary me-2"></i>Best Trainers
                  </div>
                </div>
                <div class="row g-4">
                  <div class="col-sm-6">
                    <a class="btn btn-primary py-3 px-5" href="">
                      Read More
                    </a>
                  </div>
                  <div class="col-sm-6">
                    <a
                      class="d-inline-flex align-items-center btn btn-outline-primary border-2 p-2"
                      href="tel:+0123456789"
                    >
                      <span class="flex-shrink-0 btn-square bg-primary">
                        <i class="fa fa-phone-alt text-white"></i>
                      </span>
                      <span class="px-3">+012 345 6789</span>
                    </a>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
  );
}

export default About;
